<template>
  <div :class="['branch-selection-dialog-content', variantClass]">
    <!-- Privilege variant (with invoice/grand_total fields) -->
    <template v-if="variant === 'privilege'">
      <div>
        <div class="modal-confirm-custom text-center f-title mb-3">
          {{ $t("please_fill_data") || "กรุณากรอกข้อมูล" }}
        </div>
        <v-row>
          <v-col>
            <InputSelect
              v-model:value="selected"
              :title="$t('branch_select_coupon')"
              :options="branch"
              @change="selectBranch"
              :placeholder="$t('branch_select_coupon')"
              value-field="id"
              text-field="name"
              :isValidate="errorSelectBranch"
              data-test="modal-select-branch-dropdown"
            >
              <template v-slot:prepend-item>
                <v-list-item :value="null" disabled>
                  --- {{ $t("branch_select_coupon") }} ---
                </v-list-item>
              </template>
            </InputSelect>
            <div class="text-error" v-if="errorSelectBranch">
              Please Select Branch
            </div>
          </v-col>
          <template v-if="detail && detail.is_customer_fill_invoice == 1">
            <v-col cols="12">
              <InputText
                v-model:value="v$.body.invoice_no.$model"
                :textFloat="$t('invoice_no')"
                :placeholder="$t('placeholder') + $t('invoice_no')"
                type="text"
                name="invoice_no"
                size="lg"
                :isRequired="detail.is_customer_fill_invoice == 1"
                :isValidate="v$.body.invoice_no.$error"
                :v="v$.body.invoice_no"
                class="f-regular"
                data-test="modal-select-branch-invoice-input"
              />
            </v-col>
            <v-col cols="12">
              <InputText
                v-if="
                  detail.is_customer_fill_invoice == 1 &&
                  detail.is_applied_to_existing == 0
                "
                v-model:value="v$.body.grand_total.$model"
                :textFloat="$t('grand_total')"
                :placeholder="$t('placeholder') + $t('grand_total')"
                type="number"
                name="grand_total"
                size="lg"
                :isRequired="
                  detail.is_customer_fill_invoice == 1 &&
                  detail.is_applied_to_existing == 0
                "
                :isValidate="v$.body.grand_total.$error"
                :v="v$.body.grand_total"
                class="f-regular"
                data-test="modal-select-branch-spend-input"
              />
            </v-col>
          </template>
        </v-row>
      </div>
      <div class="pt-5 text-center">
        <v-row>
          <v-col>
            <c-btn
              @click="confirmPrivilege"
              class="w-100 btn-confirm"
              variant="confirm-primary"
              :disabled="isDisable"
              data-test="modal-select-branch-confirm-btn"
            >
              {{ $t("confirm") }}
            </c-btn>
            <c-btn
              block
              @click="onClose"
              variant="outline-primary"
              class="mt-3"
              data-test="modal-select-branch-cancel-btn"
            >
              {{ $t("cancel") }}
            </c-btn>
          </v-col>
        </v-row>
      </div>
    </template>

    <!-- Reward variant -->
    <template v-else>
      <div class="reward-branch-sheet__content">
        <div
          class="reward-branch-sheet__title"
          data-lang="branch_select_coupon"
        >
          {{ $t("reward_confirm_redeem_title") }}
        </div>

        <InputSelect
          v-model:value="selected"
          :title="$t('branch_select_coupon')"
          data-test="reward-modal-select-branch-select"
          :options="
            selectedBranchList && selectedBranchList.length > 0
              ? selectedBranchList
              : branch
          "
          @change="selectBranch"
          :placeholder="$t('branch_select_coupon')"
          value-field="id"
          text-field="name"
          :isValidate="errorSelectBranch"
        >
          <template v-slot:prepend-item>
            <v-list-item :value="null" disabled>{{
              $t("branch_select_coupon")
            }}</v-list-item>
          </template>
        </InputSelect>
        <div
          class="reward-branch-sheet__error"
          v-if="errorSelectBranch"
          data-test="reward-modal-select-branch-error-msg"
        >
          {{ $t("branch_select_coupon") }}
        </div>
      </div>
      <div class="modal-qr-v2__actions">
        <c-btn
          @click="confirmReward"
          :disabled="isDisable"
          variant="confirm-primary"
          block
          data-test="reward-modal-select-branch-confirm-btn"
          >{{ $t("confirm") }}</c-btn
        >
        <c-btn
          v-if="
            lineLayout == 'Compact' ||
            lineLayout == 'standard-v2' ||
            $isStandardV2 ||
            $isVisionVenture
          "
          block
          class="mt-2"
          @click="onClose"
          variant="outline-primary"
          data-test="reward-modal-select-branch-cancel-btn"
        >
          {{ $t("cancel") }}
        </c-btn>
      </div>
    </template>
  </div>
</template>

<script>
import { useVuelidate } from "@vuelidate/core";
import { requiredIf } from "@vuelidate/validators";

export default {
  name: "BranchSelectionDialogContent",
  props: {
    variant: {
      type: String,
      default: "reward", // 'privilege' | 'reward'
      validator: v => ["privilege", "reward"].includes(v)
    },
    branch: {
      required: true,
      type: Array
    },
    detail: {
      required: false,
      type: Object,
      default: () => ({})
    },
    initialBranchId: {
      type: [Number, String, null],
      default: null
    },
    redeemQty: { required: false, default: 1 },
    randomReward: { required: false, default: false },
    isBottomSheet: { type: Boolean, default: false }
  },
  emits: ["action", "close"],
  setup() {
    return { v$: useVuelidate() };
  },
  validations() {
    return {
      body: {
        invoice_no: {
          required: requiredIf(
            () =>
              this.variant === "privilege" &&
              this.detail &&
              this.detail.is_customer_fill_invoice == 1 &&
              this.detail.is_applied_to_existing == 0
          )
        },
        grand_total: {
          required: requiredIf(
            () =>
              this.variant === "privilege" &&
              this.detail &&
              this.detail.is_customer_fill_invoice == 1 &&
              this.detail.is_applied_to_existing == 0
          )
        }
      }
    };
  },
  data() {
    return {
      selected: this.initialBranchId || null,
      body: {
        grand_total: 0,
        invoice_no: ""
      },
      isDisable: this.initialBranchId ? false : true,
      errorSelectBranch: false,
      selectedBranchList: []
    };
  },
  computed: {
    variantClass() {
      return `branch-selection-dialog-content--${this.variant}`;
    }
  },
  mounted() {
    if (
      this.variant === "reward" &&
      this.$store &&
      this.$store.state.shortProfile &&
      this.$store.state.shortProfile.customer_branch_id &&
      this.$store.state.shortProfile.customer_branch_id.length > 0
    ) {
      this.selectedBranchList =
        this.$store.state.shortProfile.customer_branch_id;
    }
  },
  methods: {
    selectBranch(evt) {
      if (evt) {
        this.errorSelectBranch = false;
        this.isDisable = false;
        return;
      }
      this.$emit("action", { action: "branchChange", value: evt });
    },
    confirmPrivilege() {
      this.v$.body.$touch();
      if (this.v$.body.$error) return;
      if (!this.selected) {
        this.errorSelectBranch = true;
        return;
      }
      this.$emit("action", {
        action: "confirm",
        branchId: this.selected,
        body: this.body
      });
    },
    confirmReward() {
      if (!this.selected) {
        this.errorSelectBranch = true;
        return;
      }
      this.$emit("action", {
        action: "showPointUsedModal",
        branchId: this.selected
      });
    },
    onClose() {
      this.selected = null;
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss" scoped>
.title {
  font-weight: 600;
  padding: 15px 0;
}

.reward-branch-sheet__title {
  margin-bottom: 22px;
  color: #222;
  font-weight: 900;
  
  text-align: center;
}

.reward-branch-sheet__row {
  margin: 0;
}

.reward-branch-sheet__error {
  margin-top: 8px;
  color: #e00012;
  font-size: var(--font-helper);
}

::v-deep .btn-secondary:hover {
  color: #fff;
  background-color: #000000;
  border-color: #000000;
}
</style>
